
import React, { createContext, useContext, useState } from 'react';
import ConfettiEffect from './confetti-effect';

interface ConfettiContextType {
  showConfetti: (position?: { x: number, y: number, width?: number, height?: number }) => void;
}

const ConfettiContext = createContext<ConfettiContextType | undefined>(undefined);

export const useConfetti = () => {
  const context = useContext(ConfettiContext);
  if (!context) {
    throw new Error('useConfetti must be used within a ConfettiProvider');
  }
  return context;
};

export const ConfettiProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isConfettiActive, setIsConfettiActive] = useState(false);
  const [confettiPosition, setConfettiPosition] = useState<{ 
    x: number; 
    y: number; 
    width?: number; 
    height?: number; 
  } | undefined>(undefined);

  const showConfetti = (position?: { x: number; y: number; width?: number; height?: number; }) => {
    setConfettiPosition(position);
    setIsConfettiActive(true);
    // Reset after animation duration
    setTimeout(() => {
      setIsConfettiActive(false);
    }, 3200); // Slightly longer than the animation duration
  };

  return (
    <ConfettiContext.Provider value={{ showConfetti }}>
      {isConfettiActive && <ConfettiEffect sourcePosition={confettiPosition} />}
      {children}
    </ConfettiContext.Provider>
  );
};
